import { homeConstants } from "../constants";

export default function (
  state = {
    isProgress: false,
    data: {},
  },
  action
) {
  switch (action.type) {
    case homeConstants.SAVE_REFILL_REMINDER_REQUEST:
      return {
        ...state,
        data: {},
        isProgress: true,
      };
    case homeConstants.SAVE_REFILL_REMINDER_SUCCESS: {
      return {
        ...state,
        data: action.response,
        isProgress: false,
      };
    }
    case homeConstants.SAVE_REFILL_REMINDER_FAILURE:
      return {
        ...state,
        data: null,
        isProgress: false,
      };
    case homeConstants.RESET_REFILL_REMINDER_INFO:
      return {
        ...state,
        data: {},
        isProgress: false,
      };
    default:
      return state;
  }
}
